import { Button } from '@cred/neopop-web/lib/components';
import Workshops from "../data/workshops.json"
import Technical from "../data/technical.json"
import NonTechnical from "../data/non_technical.json"
import { Link, useParams } from 'react-router-dom';
import Carousel from './Carousel';
import Slider from './Slider';

const EventPage = () => {

	const handleClick = ( link ) => {
		window.location.href = link;
	}

	let Data
	let {key} = useParams();

	if(key.charAt(0) === "w") {
		Data = Workshops
	} else if(key.charAt(0) === "t") {
		Data = Technical
	} else {
		Data = NonTechnical
	}

	let title = Data[key].title
	let desc = Data[key].desc
	let price = Data[key].price
	let link = Data[key].link
	let time = Data[key].time
	let venue = Data[key].venue
	let long_desc = Data[key].long_desc
	let rules = Data[key].rules
	let contact = Data[key].contact
	let poster_link = Data[key].poster_link
	let qr_link = Data[key].qr_link
	let prize_pool = Data[key].prize_pool
	let status = Data[key].status

	const words = [
		<p className="font-bold">TECHKSHETRA</p>,
		"*",
		"2022",
		"*",
		<p className="font-bold">WORKSHOPS</p>,
		"*",
		"TECHTALKS",
		"*",
		<p className="font-bold">FOOD</p>,
		"*",
		"AMPLIFY",
		"*",
	];

    return (
		<div>
			<div className="w-4/5 mt-24 mx-auto flex justify-between flex-wrap md:flex-col">

				{/*Description*/}
				<div className="text-white w-4/6 px-10 mt-10 smm:px-0 md:w-full lg:w-3/6 md:px-0 lg:px-5">
					<h3 className="text-4xl font-bold">{title}</h3>
					<p className="text-lg py-4 border-b border-gray-600 mb-4">{desc}</p>
					<div className='w-1/2 md:w-full lg:w-3/4 sm:w-full'>
						<img src={poster_link} alt="Poster"/>
					</div>
					<div className='flex flex-wrap mt-4'>
						{/* <p className='text-lg uppercase mt-4'>Time:</p> */}
						<Link to="/schedule"><p className="text-lg font-semibold w-fit p-2 rounded-sm my-2 mr-4 border border-gray-600 hover:bg-neutral-900">Time : {time}</p></Link>
						{/* <p className='text-lg uppercase mt-4'>Venue:</p> */}
						<p className="text-lg font-semibold w-fit p-2 rounded-sm my-2 mr-4 border border-gray-600">Venue : {venue}</p>
						{/* <p className='text-lg uppercase mt-4'>Prizes Worth:</p> */}
						{ prize_pool !== "" ? <p className="text-lg font-semibold w-fit p-2 rounded-sm my-2 mr-4 border border-gray-600">Prizes Worth : {prize_pool}</p> : <p></p>}
					</div>
					<div className='my-4 py-4 border-y border-gray-600'>
						{long_desc.map(a => <p className="text-md py-1 text-justify">{a}</p>)}
					</div>
					<h4 className='font-semibold text-xl'>Rules and Regulations</h4>
					<div className='my-2'>
						{rules.map(a => <p className="text-md py-1 text-justify">• {a}</p>)}
					</div>
					{/* <p className='text-lg uppercase mt-4'>Contact:</p> */}
					<p className="text-lg font-semibold w-fit p-2 rounded-sm mt-4 mb-10 border border-gray-600 md:my-8">Contact : {contact}</p>
				</div>

				{/*Payment*/}
				<div className="w-2/6 p-4 bg-white text-black md:mx-auto md:w-full md:mb-14 mt:mt-0 lg:w-[40%]">
					<h3 className='pb-4 text-3xl font-bold border-b border-gray-600'>Register</h3>
					{/* <p className='pt-3'>{UID !== '' ? `Logged in as ${email}.` : "Please log in to register."}</p> */}
					<h4 className='text-2xl bg-black rounded-sm text-white font-bold p-2 my-4'>₹{price}</h4>
					<p className='my-4 pb-4 text-justify border-b border-gray-600'>Scan the below QR Code or click the register button below and you will be redirected to our payments page to register for this event.</p>
					<img src={qr_link} className="w-5/6 mb-5 mx-auto" alt='QRCode'/>
					<div className='py-6 mb-12 border-y border-gray-600'>
						<Button
							variant="primary"
							kind="elevated"
							size="big"
							colorMode="dark"
							onClick={() => handleClick(link)}
							disabled={status !== "Register"}
						>
							{status}
						</Button>
					</div>
				</div>
			</div>

			<Slider words={words}/>
			<Carousel id={key}/>
		</div>
    );
  };
  
  export default EventPage;
  